export const toDiscountLocaleString = (money: number) => {
  if (money > 0) return `-${money.toLocaleString()}원`;
  if (money === 0) return `0원`;
};

export const toPhoneNumberString = (phoneNumber: string) => phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
